<template>
  <base-layout>
    <div style="height: 100%;">
      <div class="row">
        <div class="col-md-12">
          <!-- <h3 style="font-weight: 600;margin: 0 0 15px; color: #19223D;">Hi there!</h3> -->
          <h3 style="font-weight: 600;margin: 0 0 15px; color: #19223D;">{{ name }}</h3>
        </div>
      </div>
      <div class="row" style="height: calc(100% - 32px);padding-bottom: 5px;" v-if="EmployeedetailsList && EmployeedetailsList != '' && EmployeedetailsList != null && EmployeedetailsList != undefined">
        <div class="col-md-8" style="height: 100%;">
          <!--First Row -->
          <div class="row mainClass">
            <!-- Work Authorization Type -->
            <div class="col-md-4 pR0 mBottom">
              <div class="top-box card" v-if="EmployeedetailsList.WorkAuthType != ''" :class="workAuthtext == 'Expires on' ? 'status' : workAuthtext == 'Expired on' ? 'status1':'top-box'">
                <div class="top-box__col top-box__icon-wrapper">
                  <span class="top-box__icon top-box__icon--workpermit"></span>
                </div>
                <div class="top-box__col">
                  <p class="workHeader">Work Authorization Type</p>
                  <p class="top-box__title">{{EmployeedetailsList.WorkAuthType}}
                    <span style="padding-left:6px;"  v-if="EmployeedetailsList.WorkAuthCategory != '' && EmployeedetailsList.WorkAuthCategory != null && (EmployeedetailsList.WorkAuthType == 'EAD OTHERS' || EmployeedetailsList.WorkAuthType == 'Green Card' || EmployeedetailsList.WorkAuthType == 'OPT EAD' || EmployeedetailsList.WorkAuthType == 'STEM OPT')">({{EmployeedetailsList.WorkAuthCategory}}
                    <span  v-if="EmployeedetailsList.CategoryDescription != '' && EmployeedetailsList.CategoryDescription != null && (EmployeedetailsList.WorkAuthType == 'EAD OTHERS' || EmployeedetailsList.WorkAuthType == 'Green Card' || EmployeedetailsList.WorkAuthType == 'OPT EAD' || EmployeedetailsList.WorkAuthType == 'STEM OPT')" v-tooltip="EmployeedetailsList.CategoryDescription" class="work_auth"><i class="fa fa-info-circle" aria-hidden="true"></i></span>)</span>
                  </p>
                  <p v-if="EmployeedetailsList.Is180DaysExt" style="color: #d80808;margin-top: -6px;">180-day Extension</p>
                  <p class="top-box__title" v-if="EmployeedetailsList.WorkAuthCategory !=null  && EmployeedetailsList.WorkAuthCategory !='' && EmployeedetailsList.IsCapGap == true && ((EmployeedetailsList.WorkAuthType == 'STEM OPT' && EmployeedetailsList.WorkAuthCategory =='C03C') || (EmployeedetailsList.WorkAuthType == 'OPT EAD' && EmployeedetailsList.WorkAuthCategory =='C03B'))" style="display:inline-block;margin-left:3px;color: red">(CAP-GAP)</p>
                  <P id="duration" v-if="EmployeedetailsList.WorkAuthType != 'US Citizen'">
                    {{workAuthtext}}
                    <b style="color:#707070">{{EmployeedetailsList.WorkAuthValidity}}</b>
                  </P>
                  <P id="duration" v-else>
                    <b style="color:#707070">{{'N/A'}}</b>
                  </P>
                </div>
              </div>
              <div class="top-box card" v-else>
                <div class="top-box__col top-box__icon-wrapper">
                  <span class="top-box__icon top-box__icon--lca"></span>
                </div>
                <div class="top-box__col">
                  <div class="top-box__title">No Work <br>Authorization added</div>
                </div>
              </div>
            </div>
            <!--End Work Authorization Type -->

            <!--LCA -->
            <div class="col-md-4 pR0 mBottom" v-if="EmployeedetailsList.showLCACard == true">
              <div class="top-box card" v-if="EmployeedetailsList.LCACaseNumber != '' && EmployeedetailsList.LCACaseNumber != null && EmployeedetailsList.LCACaseNumber != undefined">
                <div class="top-box__col top-box__icon-wrapper">
                  <span class="top-box__icon top-box__icon--lca"></span>
                </div>
                <div class="top-box__col">
                  <p class="workHeader">Linked LCA</p>
                  <p
                    class="top-box__title" @click="navigateToh1b" style="cursor:pointer"
                  >{{EmployeedetailsList.LCACaseNumber}}</p>
                  <P id="role_text" :title="EmployeedetailsList.SOCTitle">{{EmployeedetailsList.SOCTitle}}</P>
                </div>
              </div>
              <div class="top-box card" v-else>
                <div class="top-box__col top-box__icon-wrapper">
                  <span class="top-box__icon top-box__icon--lca"></span>
                </div>
                <div class="top-box__col">
                  <div class="top-box__title">No LCA Linked</div>
                </div>
              </div>
            </div>
            <!--End LCA-->

            <!-- Projects -->
            <div class="col-md-4 pR0 mBottom">
              <div class="top-box card" v-if="ProjectDetails && (ProjectDetails.Name != null || ProjectDetails.Name != '' || ProjectDetails.Name != undefined)">
                <div class="top-box__col top-box__icon-wrapper">
                  <span class="top-box__icon top-box__icon--project"></span>
                </div>
                <div class="top-box__col">
                  <div class="col-md-6 workHeader pR0">Current Project</div>
                  <div class="col-md-6 m0 pL0">
                    <p class="statusCls">{{ProjectDetails.ProjectStatus == 'OnGoing' ? 'ON GOING' : 'YET TO START'}}</p>
                  </div>
                  <div style="padding-left:0px" class="col-md-12">
                    <span class="top-box__title" @click="navigateToProject"><span style="cursor:pointer;text-overflow: ellipsis;overflow: hidden;width: 130px;white-space:nowrap;display:inline-block;" :title="ProjectDetails.Name">
                    {{ProjectDetails.Name}}</span>
                      <span style="color: #4A90E2;font-size:15px;padding-left:4px;font-weight: 650;" v-if="projectsCount > 1">+{{projectsCount - 1}}</span>
                    </span>
                  <P id="duration" v-if="ProjectDetails.ProjectStatus == 'OnGoing'">
                    Project ends in
                    <b style="color:#707070">{{projectExpiryDays(ProjectDetails.EndDate)}}</b>
                  </P>
                  <P id="duration" v-else>
                    Project starts in
                    <b style="color:#707070">{{projectExpiryDays(ProjectDetails.StartDate)}}</b>
                  </P>
                  </div>
                </div>
              </div>
              <div style="cursor:pointer" class="top-box card" v-else>
                <div class="top-box__col top-box__icon-wrapper">
                  <span class="top-box__icon top-box__icon--project"></span>
                </div>
                <div class="top-box__col">
                  <div class="top-box__title">No Current Project!</div>
                </div>
              </div>
            </div>
            <!-- End Projects -->

            <!-- Leave Balance-->
            <div class="col-md-4 pR0 mBottom">
              <div class="top-box card">
                <div class="top-box__col top-box__icon-wrapper">
                  <span class="top-box__icon top-box__icon--leave"></span>
                </div>
                <div class="top-box__col">
                  <p class="top-box__count">{{BalanceLeaves}} of {{TotalLeaves}}</p>
                  <p class="top-box__title">Leave Balance</p>
                  <p style="font-size: 12px;color: #91959E;font-weight: 550;"><router-link :to="{name: 'leave-management'}">
                    Apply leave
                    <i class="fa fa-long-arrow-right"></i>
                  </router-link></p>
                </div>
              </div>
            </div>
            <!--End Leave Balance-->

            <!--Supervisor -->
            <div class="col-md-4 pR0 mBottom" v-if="!isSupervisor && this.EmployeedetailsList.IsTrainee == true">
              <div class="top-box card" v-if="SupervisorDetails && (SupervisorDetails.Email != null || SupervisorDetails.Email != '' || SupervisorDetails.Email != undefined)">
                <div class="col-md-6 titleHead">Supervisor</div>
                <div class="col-md-6 tileicons pL0">
                  <div class="box_icons">
                    <div class="col-md-3" style="margin-left: 30px;margin-right: 10px;">
                      <p v-if="SupervisorDetails.Email != '' && SupervisorDetails.Email != null && SupervisorDetails.Email != undefined">
                        <a v-if="copyShow" href="#"  @click="copyEmail(SupervisorDetails.Email)"> <span style="font-size:11px;" :title="SupervisorDetails.Email" v-tooltip.top="'Click to copy the email address'"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/dash-board/ic_email.svg`"/></span></a>
                        <a v-else><span style="font-size:11px;" :title="SupervisorDetails.Email" v-tooltip.top="'Email address copied to clipboard'"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/dash-board/ic_email.svg`"/></span></a>
                      </p>
                      <p v-else> <img style="margin-right: 2px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/dash-board/ic_email.svg`"/></p>
                    </div>
                    <div class="col-md-3">
                      <p v-if="SupervisorDetails.PhoneNumber != '' && SupervisorDetails.PhoneNumber != null"><span style="font-size:11px;" v-tooltip.top="SupervisorDetails.PhoneNumber"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/dash-board/ic_phone.svg`" /> </span> </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 pL0">
                  <div style="float:left" class="top-box__icon-wrapper">
                    <span>
                      <img
                        class="imgStyle"
                        :src="getProfilePic(SupervisorDetails.ProfilePicLink)"
                        width="35"
                        height="35"
                        alt
                      >
                    </span>
                  </div>
                  <div>
                    <p :title="getName(SupervisorDetails.FirstName,SupervisorDetails.LastName)" style="text-overflow: ellipsis;overflow: hidden;width: 130px;white-space:nowrap" class="top-box__title">{{getName(SupervisorDetails.FirstName,SupervisorDetails.LastName)}}</p>
                    <!-- <P id="duration">{{SupervisorDetails.Designation}}</P> -->
                  </div>
                </div>
              </div>
              <div class="top-box card" v-else>
                <div class="top-box__col top-box__icon-wrapper">
                  <span class="top-box__icon top-box__icon--trainee"></span>
                </div>
                <div class="top-box__col">
                  <div class="top-box__title">No Supervisor Assigned!</div>
                </div>
              </div>
            </div>
            <!--End Supervisor -->

            <!--Reporting Employees -->
            <div class="col-md-4 pR0 mBottom" v-if="!this.EmployeedetailsList.IsTrainee">
              <div class="top-box card" v-if="Trainee && Trainee.length > 0">
                <div class="col-md-8 titleHead">Reporting Employees/Trainees</div>
                <div class="col-md-4 pL0" style="padding-top:18px;text-align: right;font-size:12px;">
                  <p style="font-size: 12px;color: #91959E;font-weight: 550;"><router-link :to="{name: 'ReportingEmployees'}">
                    View all
                  <i class="fa fa-long-arrow-right"></i>
                  </router-link></p>
                </div>
                <div class="col-md-12" style="margin-left:8px;">
                  <reporting-training-circle :Trainees.sync="Trainee"></reporting-training-circle>
                </div>
              </div>
              <div class="top-box card" v-else>
                <div class="top-box__col top-box__icon-wrapper">
                  <span class="top-box__icon top-box__icon--trainee"></span>
                </div>
                <div class="top-box__col">
                  <div class="top-box__title">No Reporting Employees/Trainees</div>
                </div>
              </div>
            </div>
            <!-- End Reporting Employees -->

            <!--HR Manager -->
            <div class="col-md-4 pR0 mBottom" v-if="HrManagerDetails.Email != '' && HrManagerDetails.Email != null && HrManagerDetails.Email != undefined">
              <div class="top-box card">
                <div class="col-md-6 titleHead">HR Manager</div>
                <div class="col-md-6 tileicons pL0">
                  <div class="box_icons">
                    <div class="col-md-3" style="margin-left: 30px;margin-right: 10px;">
                      <p v-if="HrManagerDetails.Email != '' && HrManagerDetails.Email != null &&  HrManagerDetails.Email != undefined">
                        <a v-if="copyShow" href="#"  @click="copyEmail(HrManagerDetails.Email)"> <span style="font-size:11px;" :title="HrManagerDetails.Email" v-tooltip.top="'Click to copy the email address'"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/dash-board/ic_email.svg`"/></span></a>
                        <a v-else><span style="font-size:11px;" :title="HrManagerDetails.Email" v-tooltip.top="'Email address copied to clipboard'"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/dash-board/ic_email.svg`"/></span></a>
                      </p>
                      <p  v-else> <img style="margin-right: 2px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/dash-board/ic_email.svg`"/></p>
                    </div>
                    <div class="col-md-3">
                      <p v-if="HrManagerDetails.PhoneNumber != '' && HrManagerDetails.PhoneNumber != null"><span style="font-size:11px;" v-tooltip.top="HrManagerDetails.PhoneNumber"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/dash-board/ic_phone.svg`" /> </span></p>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 pL0">
                  <div style="float:left" class=" top-box__icon-wrapper">
                    <span>
                      <img class="imgStyle" :src="getProfilePic(HrManagerDetails.ProfilePicLink)" height="35" width="35" alt="">
                    </span>
                  </div>
                  <div>
                    <p :title="getName(HrManagerDetails.FirstName,HrManagerDetails.LastName)" style="text-overflow: ellipsis;overflow: hidden;width: 130px;white-space:nowrap" class="top-box__title">{{getName(HrManagerDetails.FirstName,HrManagerDetails.LastName)}}</p>
                    <!-- <P id="duration">{{HrManagerDetails.Designation}}</P> -->
                  </div>
                </div>
              </div>
            </div>
            <!--End HR Manager -->
          </div>
          <!--End First Row -->

          <!--Second Row -->
          <div class="row" style="height: calc(100% - 130px);">

            <!--Calender -->
            <div class="col-md-6" style="margin-top: 15px;">
              <div class="card" style="padding: 15px 15px 0 15px;  background: #fff;min-height:446px">
                <dashboard-calender :IsTimesheetEdit="IsEditTimesheet"></dashboard-calender>
              </div>
            </div>
            <!--End Calender -->

            <!--chart -->
            <div class="col-md-6 card" style="margin-top: 15px;padding-bottom: 10px;background-color: #fff;">
              <div style="padding: 0;  background: #fff;min-height:436px">
                <leave-report @AppliedLeavesSum="AppliedLeavesSum" @BalanceLeavesSum="BalanceLeavesSum" @PendingLeavesSum="PendingLeavesSum" @TotalLeavesSum="TotalLeavesSum"></leave-report>
              </div>
            </div>
            <!--End Chart -->
          </div>
          <!--End Second Row -->
        </div>
        <!--End Second Row -->
        <div class="col-md-4" style="height: 100%">
          <alerts></alerts>
        </div>
      </div>
      <div class="top-box__icon--dashboard" style="height:calc(100vh - 32px);" v-else>
    </div>
    </div>
  </base-layout>
</template>
<script>
import Alerts from "./ESSDashboard/Alerts.vue";
import ReportingTraineeCircle from "./ESSDashboard/ReportingTraineeCircle";
import DashboardCalender from "./ESSDashboard/DashboardCalender.vue";
import LeaveReport from './ESSDashboard/LeaveReport.vue'
import c from '@/components/Core/constants.js'
export default {
  data() {
    return {
      empInfo: "",
      EmployeedetailsList:'',
      Trainee : [],
      copyShow: true,
      ProjectDetails:[],
      SupervisorDetails:[],
      HrManagerDetails:[],
      AppliedLeaves:0,
      BalanceLeaves:0,
      PendingLeaves:0,
      TotalLeaves:0,
      IsEditTimesheet: false
    }
  },
  components: {
    "reporting-training-circle": ReportingTraineeCircle,
    "alerts": Alerts,
    "dashboard-calender": DashboardCalender,
    "leave-report":LeaveReport,
  },
  computed: {
    // hi there changes
    name() {
      if (this.loggedInUserObj && this.loggedInUserObj.name) {
        return `Hi ${this.loggedInUserObj.name}!`;
      } else {
        return "Hi there!";
      }
    },
    leaveBalance()
    {
      return  parseInt(this.AppliedLeaves)
    },
    workAuthtext()
    {
      var currentDate = moment().format('MM/DD/YYYY')
      var days = moment(this.EmployeedetailsList.WorkAuthValidity).diff(currentDate, 'days');
      if(days > 0 || days == 0 )
      {
        return 'Expires on'
      }
      else if(days < 0)
      {
        return 'Expired on'
      }
    },
    EmployeeId()
    {
      return this.loggedInUserObj.empId ? this.loggedInUserObj.empId : '';
    },
    lcaCount() {
      return this.EmployeedetailsList && this.EmployeedetailsList.LCACaseNumber && this.EmployeedetailsList.LCACaseNumber.length
    },
    projectsCount(){
      return this.EmployeedetailsList && this.EmployeedetailsList.Project && this.EmployeedetailsList.Project.length
    },
    isSupervisor()
    {
      return this.loggedInUserObj.IsSupervisor ? this.loggedInUserObj.IsSupervisor : '';
    }
  },
  created(){
    document.body.classList.add("height-auto")
    this.getDetails()
    this.getTraineeEmployee()
    this.getIsEditTimesheet()
  },
  mounted() {
    // Call organizationList when the component is mounted to fetch the data
    this.organizationList();
  },

  destroyed() {
    document.body.classList.remove("height-auto")
  },
  methods: {
    AppliedLeavesSum(v)
    {
      this.AppliedLeaves =  v ? v : 0
    },
    BalanceLeavesSum(v)
    {
      this.BalanceLeaves =   v ? v : 0
    },
    PendingLeavesSum(v)
    {
        this.PendingLeaves = v ? v:0
    },
    TotalLeavesSum(v){
        this.TotalLeaves = v ? v:0
    },
    projectExpiryDays(EndDate){
      if (!EndDate || moment(EndDate).isSame(moment("0001-01-01T00:00:00"), "day")) {
    return "NO Expiration";
    }
      var projectDate = EndDate
      var currentDate = moment()
      var years = moment(projectDate).diff(currentDate, 'year');
        currentDate.add(years, 'years');

      var months = moment(projectDate).diff(currentDate, 'months');
        currentDate.add(months, 'months');

      var weeks = moment(projectDate).diff(currentDate, 'weeks');
        currentDate.add(weeks, 'weeks');

      var days = moment(projectDate).diff(currentDate, 'days');

      var sameday = moment(projectDate).isSame(currentDate, 'days');

      var str = '';

      if(years > 0)
      {
        str += years + (years > 1 ? ' Years ' : ' Year ')
      }
      if(months > 0)
      {
        str += months + (months > 1 ? ' Months ' : ' Month ')
      }
      if(weeks > 0)
      {
        str += weeks + (weeks > 1 ? ' Weeks ' : ' Week ')
      }
      if(days > 0)
      {
        str += days + (days > 1 ? ' Days ' : ' Day ')
      }
      if(sameday){
        str += '0 days'
      }
      return str
    },
    assignValues()
    {
      this.ProjectDetails = this.EmployeedetailsList.Project[0],
      this.SupervisorDetails = this.EmployeedetailsList.UserDetails.filter(v=>v.CurrentRole == 'Supervisor')[0]
      this.HrManagerDetails = this.EmployeedetailsList.UserDetails.filter(v=>v.CurrentRole == 'HRManager')[0]
    },
    getName(f,l){
      var fName =  f ? f :''
      var lName = l ? l : ''
      return fName+ " " + lName
    },
    getProfilePic(ProfilePicLink) {
      if (ProfilePicLink != null && ProfilePicLink != '')
        return ProfilePicLink;
      else return `${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/noimage.svg`;
    },
    getDetails(){
      //  this.$loading({'loadingText': 'Loading...'})
      ajax.get(`Employee/${this.EmployeeId}/DashBoardDetails`,{},(res)=>{
        if(res.data.State){
          this.EmployeedetailsList = res.data.BasicDetails
          this.assignValues()
        }
        else{
          if(res.data.Status && res.data.Status == "ESSLogOut"){
            localStorage.removeItem("access_token")
            localStorage.removeItem("user_details")
            window.location.href = c.APPLICATIONBASEURL
          }
        }
        // this.$loading({}).close()
      })
    },
    // hi There changes
    organizationList() {
      ajax.get(
        `Employee/${loggedInUserObj.consultantId}/EmployeeOrganizationList`,
        {},
        res => {
          if (res.data.State == true) {
            this.empInfo = res.data.organizationBasicInfoList.EmployeeInfo;
            // You can add more processing here if needed
          } else {
            this.ESSEnableDisable(res);
          }
        }
      );
    },
    getTraineeEmployee() {
      ajax.get(
        `/Supervisor/GetReportingEmployeeList?empId=${loggedInUserObj.empId}`,
        {},
        res => {
          this.Trainee = res.data.resultList;
        }
      );
    },
    getIsEditTimesheet(){
      this.$loading({'loadingText': 'Loading...'}) 
            ajax.get(`TimeSheets/Settings?orgId=${this.loggedInUserObj.orgId}`, {} , (res) => {
              if(res.data.TimesheetSettings.AllowTimeSheetUpdateAfterApproval != null && res.data.TimesheetSettings.AllowTimeSheetUpdateAfterApproval != undefined){
              this.IsEditTimesheet = res.data.TimesheetSettings.AllowTimeSheetUpdateAfterApproval.PreferenceApplied
            }
              this.$loading({}).close()
            })
    },
    copyEmail(email) {
      var mail = email
      this.copyShow = false;
      this.copyToClipboard(mail);
    },
    copyToClipboard(text) {
      var dummy = document.createElement("input");
      document.body.appendChild(dummy);
      dummy.setAttribute('value', text);
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
      setTimeout(() => {
        this.copyShow = true;
      },2000)
    },
    navigateToProject() {
      this.$router.push({ path: "/employee/projects" });
    },
    navigateToh1b(){
      var h1bId = this.EmployeedetailsList && this.EmployeedetailsList.H1BId ? this.EmployeedetailsList.H1BId : string.Empty
        this.$router.push({ name: "employee-h1b" , params: { H1BId: h1bId}})
    }
  }
}
</script>


<style lang="scss" scoped>
@import "~styles/framework/vue-utils";
@import '../../../static/Css/Content/SCSS/post-login-scss/scss/cdnVariables';
.button-section {
  padding: 0px 15px;
  /* text-align: center;*/
}

.temp-button {
  box-shadow: #ddd 0px 0px 4px;
  border: 1px solid #ddd;
  border-radius: 2px;
  color: #333;
  font-weight: 600;
  margin-right: 15px;
  width: calc(33% - 16px);
  font-size: 13px;

  &:last-child {
    margin-right: 0px !important;
    width: calc(33% - 6px);
  }
}

.temp-button:hover,
.temp-button:active,
.temp-button:focus {
  border-color: #ddd !important;
}

.new-place {
  height: 50%;
}

.past-place {
  height: 100%;
}

/* New Styles */
.top-box {
  border: 1px solid #edeef0;
  height: 115px;
  background: #fff;
  position: relative;
  display: table;
  width: 100%;
}
.card:hover{
  -webkit-box-shadow: 0px 4px 14px 0px rgba(177,180,188,0.2);
  box-shadow: 0px 4px 14px 0px rgba(177,180,188,0.2);
}
.top-box__icon-wrapper {
  text-align: center;
  width: 30%;
}
.top-box__col {
  display: table-cell;
  vertical-align: middle;
}
.top-box__icon {
  width: 35px;
  height: 35px;
  display: inline-block;
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/dash-board/ic_work-permit.svg") no-repeat;
}
.top-box__icon--project {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/dash-board/ic_current-project.svg") no-repeat;
}
.top-box__icon--leave {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/dash-board/ic_leave-balance.svg") no-repeat;
}
.top-box__icon--trainee {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/dash-board/ic_noemp-trainees.svg") no-repeat
}
.top-box__icon--lca {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/dash-board/ic_lcas-filed.svg") no-repeat;
}
.top-box__icon--dashboard{
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/dash-board/loding.svg") no-repeat;
}

.top-box__count {
  color: #19223d;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 5px;
}
.top-box__title {
  color: #19223d;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.5px;
  margin-bottom: 5px;
  margin-right: 4px;
}
.top-box a {
  color: #91959e;
}
.top-box a:hover {
  color: #337ab7;
}

.top-box__corner-text {
  position: absolute;
  top: 10px;
  right: 15px;
  text-align: right;
}
.top-box__corner-text-label {
  display: block;
  font-size: 9px;
  color: #91959e;
}
.top-box__corner-text-value {
  font-size: 11px;
  color: #19223d;
  font-weight: 600;
}
.statusCls {
  background-color: #e7f7f2;
  padding: 4px 4px 4px 4px;
  border-radius: 10px;
  font-size: 9px;
  color: #2ac697;
  font-weight: bold;
  text-align: center;
}
.box_icons {
  text-align: right;
}
.titleHead {
  font-size: 10px;
  font-weight: 500;
  padding: 20px 0px 20px 20px;
  color:#696b6f;
}
.tileicons {
  padding-top: 12px;
}
.workHeader {
  font-size: 10px;
  font-weight: 500;
  padding-bottom: 8px;
  padding-left: 0px;
  color: #696b6f;
}
.lcaIcon {
  color: #337ab7;
  font-size: 20px;
}
.imgStyle {
  border-radius: 20px;
}
.circle {
  background-color: #ff6347;
  border-radius: 50%;
  display: inline;
  padding: 5px 6px;
  border: 2px solid white;
  margin-left: -8px;
  position: sticky;
}
.circleCount {
  background-color: #ff6347;
  border-radius: 50%;
  display: inline;
  padding: 5px 3px;
  border: 2px solid white;
  margin-left: -8px;
}
#duration {
  color: #91959e;
  font-weight: 550;
}
#role_text {
  color: #91959e;
  font-weight: 550;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
}
.work_auth{
  color: #707070;
  // font-size: 12px;
  padding-left: 5px;
}

.mBottom:nth-child(-n+3) {
  padding-bottom: 15px;
}
.status{
  background-color:#FFDFB6
}
.status1{
  background-color: #F8BDC1
}
</style>




// WEBPACK FOOTER //
// src/components/ESSProfile/ESSDashboard.vue